import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { Routes, BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'mobx-react';
import stores from 'core/stores';
import { rootUrl } from 'core/config';

import CompanyJobsScreen from 'screens/CompanyJobsScreen';

const rootElement = document.querySelector('.company-jobs');

const root = ReactDOMClient.createRoot(rootElement);
root.render(
  <Provider {...stores}>
    <BrowserRouter basename={rootUrl}>
      <Routes>
        <Route path="/" index element={<CompanyJobsScreen />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
